module.exports = __webpack_public_path__ + "assets/img/D3-Security-Content-Marketing-w960.32fbde14.jpg";